import React from 'react'

import Icon from '@/icons'
import BusinessSection from '@/business-section'

import './styles.css'

const SectionGlobalPlatform = ({ gray }) => {
  return (
    <BusinessSection
      title="Global #1 platform for beauty pageants"
      subtitle="Backed by years of experience in beauty pageant industry"
      gray={gray}
    >
      <div className="flex flex-wrap br3 overflow-hidden mw560-m center mh0-l">
        <div className="bg-light-gray ph5 pt6 pb4 w-100 w-40-l">
          <div className="flex mb6 justify-center">
            <BenefitItem icon="crown" title="+200" text="pageants" iconWidth="30px" iconHeight="auto" />
            <BenefitItem icon="house" title="3" text="offices" />
            <BenefitItem icon="starFilled" title="+1mil" text="votes cast" />
          </div>

          <div className="tc">
            <Icon icon="earth-no-shadow" width="270px" className="mw-100" />
          </div>
        </div>

        <div className="dark-gold-gradient white f6 fw3 ph5 pv6 w-100 w-60-l">
          <p className="mt0 mb6">
            From design to execution, Next Miss can handle every digital aspect of your beauty pageant:
            casting, voting, judge rating, news, revenue streams, publishing tools, advertisers & sponsors.
          </p>
          <p className="mv0">
            We have successfully served beauty pageants on all 6 continents. Do not hesitate to contact us when you want to bring your beauty pageant to the next level.
          </p>
        </div>
      </div>
    </BusinessSection>
  )
}

function BenefitItem({ icon, title, text, iconSize, iconWidth, iconHeight }) {
  return (
    <div className="mh3 fw3">
      <div className="flex f6 items-baseline lh-solid">
        <Icon
          icon={icon}
          width={iconWidth || '18px'}
          height={iconHeight || '18px'}
          className="gold mr1"
          size={iconSize}
        />
        {title}
      </div>
      <div className="f11">{text}</div>
    </div>
  )
}

export default SectionGlobalPlatform



// WEBPACK FOOTER //
// ./src/components/section-global-platform/section-global-platform.js